export default "__VITE_ASSET__0d516c7a__"